/**
 * Query keys for the background catalog-refresh job.
 *
 * Deliberately its OWN ROOT KEY, not a child of smswiserCatalogKeys.all: a finished run
 * invalidates smswiserCatalogKeys.all, which would otherwise nuke the very query that is
 * polling the run (React Query matches keys by prefix, and 'smswiser-catalog-refresh-job'
 * is a different first segment, so it is never swept by that invalidation).
 * For Media Devoted | Created By Ciro Autiero
 */

export const catalogRefreshJobKeys = {
  all: ['smswiser-catalog-refresh-job'] as const,
  status: () => [...catalogRefreshJobKeys.all, 'status'] as const,
};
